import React, { HTMLAttributes } from 'react'
import { styles } from './ListBlock.css'
import { AppText } from '@otomoro/components/shared/AppText'
import { PortableTextObject } from 'sanity'
import { AppList } from '@otomoro/components/shared/AppList'
import { SectionHeader } from "@otomoro/components/shared/SectionHeader"

interface ListBlockProps extends HTMLAttributes<Element> {
	tag: string
	titleText: PortableTextObject
	description: PortableTextObject
	list: string[]
}

export const ListBlock: React.FC<ListBlockProps> = ({
	tag,
	titleText,
	description,
	list,
}) => {
	const { base } = styles()

	return (
		<section className={base()}>
			<SectionHeader tag={tag} title={titleText} description={description} noPx={true} />
			<AppList itemClassName='border-t border-black pt-2' className='col-start-4 col-end-7 flex flex-col gap-y-4 mt-4'>
				{list.map((el) => (
					<AppText
						key={el}
						size='h3'
						family='condensed'
						textTransform='uppercase'
					>
						{el}
					</AppText>
				))}
			</AppList>
		</section>
	)
}
